import React from 'react'
import Gamesecon from './Gamesecon'


const MyorderSecond = () => {
  return (
    <>
     <Gamesecon/>
    </>
  )
}

export default MyorderSecond